import { recipe } from "@vanilla-extract/recipes";
import {
  linearGradient,
  type LinearGradientStyle,
} from "@huub-web/utils/css/gradient";
import { boxShadow } from "@huub-web/utils/css/boxShadow";
import { keyframes } from "@vanilla-extract/css";

import { theme } from "../../theme/css/theme.css";
import { alignVariants } from "../../utils/vanilla/alignVariants";

const lineStops: LinearGradientStyle["stops"] = [
  [null, 0],
  [null, "calc(50% - 0.8px)"],
  [theme.colors.defaultBorder, 0.5],
  [null, "calc(50% + 0.8px)"],
  [null, 1],
];

export const loadingAnimation = keyframes({
  "0%": { transform: "translateX(-100%)" },
  "100%": { transform: "translateX(100%)" },
});

export const placeholderStyle = recipe({
  base: {
    position: "relative",
    overflow: "hidden",
    width: "100%",
  },
  variants: {
    size: {
      xs: {
        borderRadius: theme.borderRadiuses.xs,
      },
      s: {
        borderRadius: theme.borderRadiuses.s,
      },
      m: {
        borderRadius: theme.borderRadiuses.m,
      },
    },
    alignSelf: {
      ...alignVariants("alignSelf"),
    },
    variant: {
      debug: {
        boxShadow: boxShadow({
          color: theme.colors.defaultBorder,
          blur: 0,
          spread: 1,
          inset: true,
        }),
        backgroundImage: [
          linearGradient({ angle: "to top left", stops: lineStops }),
          linearGradient({ angle: "to top right", stops: lineStops }),
        ].join(", "),
      },
      loading: {
        backgroundColor: theme.colors.backgroundShade,
        "::after": {
          content: "''",
          position: "absolute",
          top: 0,
          left: "50%",
          height: "100%",
          transform: "translateX(-50%)",
          width: "var(--container-width)",
          animation: `${loadingAnimation} 1.5s infinite ease`,
          opacity: 0.6,
          background: `linear-gradient(90deg, transparent, ${theme.colors.background ?? "transparent"}, transparent)`,
        },
      },
      loadingShade: {
        backgroundColor: "rgba(0, 0, 0, 0.02)",
        "::after": {
          content: "''",
          position: "absolute",
          top: 0,
          left: "50%",
          height: "100%",
          transform: "translateX(-50%)",
          width: "var(--container-width)",
          animation: `${loadingAnimation} 1.5s infinite ease`,
          background: `linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.03), transparent)`,
        },
      },
    },
  },
  defaultVariants: {
    size: "s",
  },
});
